module.exports = __webpack_public_path__ + "static/kelemvor-symbol-DND3_FnP-0f53b439a8c6300fabf6b127de202310.jpg";